import orderApi from "@api/order";
import { useMutation } from "@tanstack/react-query"

const useDownloadOrder = (orderUuid: string) => {
    return useMutation({
        mutationFn: async () => {
            return await orderApi.printOrder(orderUuid)
        },
    })
}

export default useDownloadOrder;